<template>
    <v-app id="inspire">
        <v-container v-if="menuShow">
            <!-- Menu principal -->
            <v-navigation-drawer v-model="drawer" app>
                <v-list nav dense>
                    <v-list-item-group active-class="deep-purple--text text--accent-4">
                        <v-list-item :to="{ name: 'SubdepList' }">
                            <v-icon>mdi-bank</v-icon>
                            <v-list-item-title>&nbsp;Subdepartamentos</v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="{  name: 'PoiList', params:{'subdepId': 0} }">
                            <v-icon>mdi-map-marker</v-icon>
                            <v-list-item-title>&nbsp;POIs</v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="{ name: 'DashboardDaee' }">
                            <v-icon>mdi-tablet-dashboard</v-icon>
                            <v-list-item-title>&nbsp;Dashboard DAEE</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
            <!-- Menu direito -->
            <v-navigation-drawer
                v-model="drawerRight"
                right
                fixed
                floating
                temporary
                app
                >
                <v-card>
                    <v-card-title>
                        <v-icon>mdi-account</v-icon>&nbsp; {{ user.name }}
                    </v-card-title>
                </v-card>
                <v-list nav dense>
                    <v-list-item-group active-class="deep-purple--text text--accent-4">
                        <v-list-item v-on:click="logout">
                            <v-icon>mdi-account-cancel</v-icon>
                            <v-list-item-title>&nbsp;Logout</v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="{name:'ChangeInstance'}">
                            <v-icon>mdi-swap-horizontal</v-icon>
                            <v-list-item-title>&nbsp;Trocar instância</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-on:click="logout">
                            <v-icon>mdi-card-account-details-outline</v-icon>
                            <v-list-item-title>&nbsp;Versão: {{this.appVersionShow}}</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
        </v-container>

        <!-- Barra principal -->
        <v-app-bar app id="main-menu">
            <!-- Botão menu esquerdo -->
            <v-app-bar-nav-icon
                @click="drawer = !drawer"
                class="icon"
                v-if="menuShow"
                ></v-app-bar-nav-icon>

            <v-toolbar-title>
                <div>{{ mainTitle }}</div>
                <div id="toolbar-title-page-name">{{ pageName }}</div>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- Botão lupa -->
            <!--
            <v-btn id="menu-main-bt" icon color="#ffffff" v-if="menuShow">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            -->
            <!-- Botão menu direito > -->
            <v-btn icon color="#ffffff"
                   v-if="menuShow"
                   @click="drawerRight = true">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-progress-linear
                :active="overlay"
                :indeterminate="overlay"
                absolute
                bottom
                color="white accent-4"
                ></v-progress-linear>
        </v-app-bar>

        <v-menu> </v-menu>
        <v-main id="scroll-target">
            <router-view />
        </v-main>
        <v-overlay
            :value="overlay"
            :opacity="overlayOpacity"
            ></v-overlay>
        <Toast/>
    </v-app>
</template>
<script>
    import { EventBus } from "@/event-bus";
    import Toast from "./components/Toast";
    import { appCaller } from "./mixins/appCaller";
    import { InstanceConfigs } from "./services/InstanceConfigs";
    import { appVersion } from "../app-version.js";

    export default {
        data: function () {
            return {
                drawer: null,
                drawerRight: false,
                mainTitle: this.$appName,
                pageName: "",
                menuShow: true,
                tokenKey: this.$appTokenKey,
                user: {name: "Usuário"},
                overlay: false,
                overlayOpacity: 0.3,
                overlayOpacityDefault: 0.3,
                instanceConfigsSrv: null,
                appVersionShow: ""
            };
        },

        components: {
            Toast
        },

        mixins: [appCaller],

        beforeCreate: function () {},

        created: function () {
            EventBus.$on("eventShowMenu", this.setMenuView);
            EventBus.$on("eventPageLoad", this.applyPageLoadActions);
            EventBus.$on("eventSetUser", this.setUser);
            EventBus.$on("eventWaitingStart", this.waitFullEnable);
            EventBus.$on("eventWaitingEnd", this.waitFullDisable);
            EventBus.$on("goto_login", function () {
                return this.$router.push({name: "Login"});
            }.bind(this));

            this.instanceConfigsSrv = new InstanceConfigs();

            this.menuShow = true;

            this.appVersionShow = appVersion;
        },

        mounted: function () {
            //Atualiza informações da tela quando evento for disparado.
            this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
                this.instanceConfigsSrv.loadAll();
                console.log("UPDATE CNF");
            }.bind(this));

            EventBus.$on(this.$instanceChangeEvt, function () {
                this.instanceConfigsSrv.loadAll();
                console.log("UPDATE CNF (" + this.$instanceChangeEvt + ")");
            }.bind(this));
        },

        methods: {
            setMenuView: function (value) {
                console.log("setMenuView", value);
                this.menuShow = value;
            },

            applyPageLoadActions: function (page) {
                console.log("debug setPageName", page.name);
                this.pageName = page.name;
                this.checkIfAuthorized();
            },

            setUser: function (value) {
                console.log("setUser", value);
                this.user = value;
            },

            logout: function () {
                this.drawerRight = false;
                window.localStorage.setItem(this.tokenKey, "");
                return this.$router.push({name: "Login"});
            },

            checkIfAuthorized() {
                const token = window.localStorage.getItem(this.tokenKey);

                if (token) {
                    return;
                }

                if (this.pageName != "Login") {
                    const msg = "Acesso não autorizado! \nVerifique se está devidamente logado.";
                    EventBus.$emit("toast", {tx: msg});
                    this.$router.push({name: "Login", params: {}});
                }
            },

            waitFullEnable: function (params = {}) {

                this.overlay = true;
                this.overlayOpacity = params.opacity != "undefined"
                        ? params.opacity
                        : this.overlayOpacityDefault;
            },

            waitFullDisable: function () {
                setTimeout(() => {
                    this.overlay = false;
                    this.overlayOpacity = this.overlayOpacityDefault;
                }, 500);
            }
        }
    };
</script>
<style>
    #main-menu {
        background-color: #3f51b5;
        color: #ffffff;
    }

    #main-menu .icon {
        color: #ffffff;
    }

    #main-menu-icon {
        display: block;
    }

    .justify-center {
        margin: 0 auto;
    }

    #toolbar-title-page-name {
        font-size: 10px;
    }

    .scroll-updater-main-container {
        min-height: 1000px !important;
    }

</style>